const productCards = [
  {
    id: 1,
    title: 'Single Port Temperature and Humidity Sensor',
    description: 'Dual sensor, 2 sensors on one port. In situations where both temperature and humidity can be critical you can keep up to speed on the current conditions using this sensor. Combining temperature and humidity into the one sensor frees up an additional intelligent sensor port on your base unit.',
    imgName: '1.png',
    translateKeys: {
      title: 'singlePortSensorTitle',
      description: 'singlePortSensorDescription'
    }
  },
  {
    id: 2,
    title: 'RopeWater Sensor',
    description: 'Detect water leaks over large area. With the ropeWater sensor you can protect your essential equipment from potentially harmful water damage. Able to detect the presence or non-presence of water/battery acid The ropeWater sensor can detect and withstand a 40% concentration of battery acid for short term periods of time without damage to the rope.',
    imgName: '2.png',
    translateKeys: {
      title: 'ropeWaterSensorTitle',
      description: 'ropeWaterSensorDescription'
    }
  },
  {
    id: 3,
    title: 'AC Voltage Detector',
    description: 'The AC voltage detector is used to indicate the presence or absence of line voltage. This is useful, for example to tell when the UPS is running on battery power. The AC Voltage Detector indicates an ALARM/NORMAL condition in software and also via an LED mounted on the sensor. It is designed for use worldwide. There is an SNMP interface for getting the alarm/normal status. SNMP traps are sent when critical conditions occur.',
    imgName: '3.png',
    translateKeys: {
      title: 'acVoltageDetectorTitle',
      description: 'acVoltageDetectorDescription'
    }
  },
  {
    id: 4,
    title: 'Smoke Detector',
    description: 'Monitoring for developing smoke is an essential aspect in the security and safety of any facility. Includes disconnect alarm that checks that the sensor is securely plugged into the sensor/securityProbe.',
    imgName: '4.png',
    translateKeys: {
      title: 'smokeDetectorTitle',
      description: 'smokeDetectorDescription'
    }
  },
  {
    id: 5,
    title: 'Siren Strobe Light',
    description: 'The combined strobe light and siren can add eye-catching audio visual alarms to the sensorProbe and securityProbe series base units. When triggered, the siren generates a loud alarm accompanied with a bright flashing strobe light, giving a clear alert of an alarm condition. Powered by the base unit, with no additional power required, it\'s perfectly suited for use in mission critical situations. The siren and strobe can be triggered by another sensors status, or controlled manually via the web interface or using its own SNMP OID.',
    imgName: '5.png',
    translateKeys: {
      title: 'sirenStrobeTitle',
      description: 'sirenStrobeDescription'
    }
  },
  {
    id: 6,
    title: 'AC Voltage Detector',
    description: 'The Security sensor is a magnetic on/off switch for monitoring doors and windows. When the door, or window, opens the input signal is detected by the sensorProbe or securityProbe base unit. Alerts can then be generate to notify you even including images captured from an attached camera to give you instant visual feedback on the situation. They are active switches that close when one half of the sensor is in close proximity to its mate. When the two sensor pairs are moved apart from each other they open. The base unit senses closure and opening of these switches.',
    imgName: '6.png',
    translateKeys: {
      title: 'securitySensorTitle',
      description: 'securitySensorDescription'
    }
  }
]

export {
  productCards
};
